import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import ContactModal from './components/ContactModal';

function Navigation({ isVisible, onContactClick }) {
  const location = useLocation();
  
  const handleLogoClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  return (
    <nav className={`navigation ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/" className="logo-link" onClick={handleLogoClick}>
            <img src="/lattice_logo_blue_black_focused.svg" alt="lattice-logo" className="logo-svg" />
          </Link>
        </div>
        <div className="nav-links">
          <button 
            className="nav-link contact-btn"
            onClick={onContactClick}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}


function ScrollHandler({ children, onContactClick }) {
  return (
    <>
      <Navigation isVisible={true} onContactClick={onContactClick} />
      {children}
    </>
  );
}

function AppContent() {
  const [showContactModal, setShowContactModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = () => {
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };

  const handleFooterLogoClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 0);
    }
  };

  return (
    <div className="app">
      <div className="app-background" />
      
      {/* scrollable */}
      <div className="scrollable-content">
        <ScrollHandler onContactClick={handleContactClick}>
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home onContactClick={handleContactClick} />} />
            </Routes>
          </main>
        </ScrollHandler>
      </div>

      {/* Footer */}
      <footer className="site-footer">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-section">
              <h4>Navigation</h4>
              <nav className="footer-nav">
                <Link to="/">Home</Link>
                <a href="#" onClick={(e) => { e.preventDefault(); handleContactClick(); }}>Contact</a>
              </nav>
            </div>
            
            <div className="footer-section">
              <h4>Connect</h4>
              <div className="social-links">
                <a href="https://www.linkedin.com/company/inalab-consulting-inc/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="currentColor"/>
                  </svg>
                  LinkedIn
                </a>
                <a href="mailto:sales@inalabgroup.com" target="_blank" rel="noopener noreferrer" aria-label="Email">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                  Email
                </a>
              </div>
            </div>
            
            <div className="footer-section">
              <div className="definition">
                <div className="definition-meaning">
                  Lattice is a product of <a href="https://inalabgroup.com/" target="_blank" rel="noopener noreferrer" style={{color: '#2B9BCA', textDecoration: 'none'}}>Inalab Inc.</a>, a success accelerator delivering AI-driven solutions that enhance operational readiness and decision superiority for U.S. Federal missions.
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} Lattice. All rights reserved.</p>
            </div>
            <div className="footer-logos">
              <Link to="/" aria-label="Return to home" onClick={handleFooterLogoClick}>
                <img src="/lattice_logo_blue_black_focused.svg" alt="lattice-logo" className="footer-logo-svg" />
              </Link>
              <a href="https://inalabgroup.com/" target="_blank" rel="noopener noreferrer" aria-label="Visit Inalab Group">
                <img src="/InalabGroupLogo.svg" alt="Inalab Group" className="inalab-logo" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      {showContactModal && (
        <ContactModal onClose={handleCloseContactModal} />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
